import React from "react";
import { Link } from "react-router-dom";

class Page1 extends React.Component {
  state = {
    visible: true,
  };
  checkPageVisibility(pageNum) {
    if (pageNum == 1) {
      this.setState({
        visible: true,
      });
    } else {
      this.setState({
        visible: false,
      });
    }
  }
  render() {
    return (
      <div>
        {this.state.visible ? (
          <div className="container-fluid h-100 vertical-center ">
            <div className="row h-100 justify-content-center">
              <div className="col-lg-8 col-md-12 col-sm-12 col-xs-12">
                <div className="card mb-4 box-shadow" id="pageContent">
                  <div className="card-body d-flex flex-column text-dark">
                    <span id="moduleContentText_2">
                      If you completed the module,{" "}
                      <Link to="/Module2" target="_blank">
                        'I have some ideas and need to focus my thinking'
                      </Link>
                      , you will have learnt that the world of work is changing
                      rapidly. The work you may have done as part of your
                      internship or placement may not even exist in its current
                      form in 10 years’ time. It can feel very unsettling if
                      you’ve always wanted to do something and have now decided
                      it isn’t for you.
                      <br />
                      <br />
                      Relax, this is healthy! You are clearly gathering data
                      about yourself, what your likes and dislikes are, the
                      sorts of environments you enjoy working in and the
                      strengths you enjoy using. Approach this like a scientist,
                      what is all this information telling you? How can you
                      harness this information to inform your next steps?
                      <br />
                      <br />
                      You may find it helpful to start by thinking about your
                      values.
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    );
  }
}

export default Page1;
